import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";

type ClientEquipment =
	| {
			brand?: string | null;
			model?: string | null;
	  }
	| string;

type ClosedRepairEntry = {
	clientEquipment?: ClientEquipment | null;
	quotation?: number | null;
	storeBox?: number | string | null;
};

type ClosedRepairsTableProps = {
	repairs: ClosedRepairEntry[];
};

const formatCurrency = (value: number) =>
	new Intl.NumberFormat("pt-PT", {
		style: "currency",
		currency: "EUR",
		maximumFractionDigits: 2,
	}).format(value);

const normalizeNumber = (value: number | null | undefined) => {
	const parsed = Number(value ?? 0);
	return Number.isNaN(parsed) ? 0 : parsed;
};

const formatEquipmentLabel = (
	equipment: ClientEquipment | null | undefined,
) => {
	if (!equipment) {
		return "-";
	}

	if (typeof equipment === "string") {
		const trimmed = equipment.trim();
		return trimmed.length > 0 ? trimmed : "-";
	}

	const brand = equipment.brand?.trim() ?? "";
	const model = equipment.model?.trim() ?? "";
	const label = `${brand} ${model}`.trim();
	return label.length > 0 ? label : "-";
};

export function ClosedRepairsTable({ repairs }: ClosedRepairsTableProps) {
	return (
		<div className="overflow-hidden rounded-lg border border-border/60 bg-card/70">
			<Table>
				<TableHeader>
					<TableRow className="bg-muted/50">
						<TableHead className="w-[180px]">Client</TableHead>
						<TableHead className="w-[160px]">Valor</TableHead>
						<TableHead className="w-[160px]">Caixa</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					{repairs.map((repair) => {
						const equipmentLabel = formatEquipmentLabel(repair.clientEquipment);
						const rowKey = `${equipmentLabel}-${repair.storeBox ?? "box"}-${
							repair.quotation ?? "value"
						}`;

						return (
							<TableRow key={rowKey}>
								<TableCell>{equipmentLabel}</TableCell>
								<TableCell>
									{formatCurrency(normalizeNumber(repair.quotation))}
								</TableCell>
								<TableCell>{repair.storeBox ?? "-"}</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</div>
	);
}
